"use client"

import { useId, useState } from "react"

import { Icon, Tooltip } from "@/shared/ui/atoms"

// 평점 산출 기준 안내. 화면 평점은 entities/hospital/lib/rating의 1~5점 환산값이다.
// 만점을 밝히지 않으면 10점 만점으로 오독되고, 정렬 기준을 밝히지 않으면
// 카드 좌측 숫자가 평점 순위로 읽힌다. 둘 다 확인된 사실만 적는다.
export const RATING_BASIS_CONTENT = "평점은 공개 리뷰 데이터를 분석해 1~5점으로 환산한 값입니다.\n리뷰 수는 해당 병원에 등록된 공개 리뷰 개수입니다.\n목록 순서는 평점순이 아니며, 카드 왼쪽 숫자는 이 목록에서의 순번입니다."

/**
 * 모바일이 주 사용처라 hover만으로는 열리지 않는다(터치에는 hover가 없고 iOS Safari는
 * 버튼 탭에 포커스를 주지 않는 경우가 많다). RankingMetaBar와 같이 click 토글 +
 * hover/focus를 모두 처리한다. 안내 문구 자체는 아래 sr-only 문단으로 항상 SSR HTML에 남는다.
 */
const RatingBasisTooltip = () => {
  const tooltipId = useId()
  const descriptionId = `${tooltipId}-description`
  const [isOpen, setIsOpen] = useState(false)

  return (
    <span className="inline-flex items-center">
      <span
        className="relative inline-flex items-center"
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        <button
          type="button"
          aria-describedby={descriptionId}
          aria-expanded={isOpen}
          aria-label="평점 기준 안내 열기"
          className="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-white px-2 py-1 text-[11px] font-medium text-gray-600"
          onClick={() => setIsOpen((previous) => !previous)}
          onFocus={() => setIsOpen(true)}
          onBlur={() => setIsOpen(false)}
        >
          평점 기준
          <Icon src="/icons/tooltip.png" alt="" width={12} height={12} className="shrink-0 opacity-80" />
        </button>
        {/* 트리거가 목록 헤더 우측 끝이라 중앙 정렬이면 390px 뷰포트에서 박스가 잘린다 */}
        {isOpen ? <Tooltip content={RATING_BASIS_CONTENT} align="right" /> : null}
      </span>
      <p id={descriptionId} className="sr-only">{RATING_BASIS_CONTENT}</p>
    </span>
  )
}

export default RatingBasisTooltip
